module.exports = __webpack_public_path__ + "static/media/md-open.39dc2eb5.svg";